// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__14eo9","sendOtp":"AuthorizeToLogin_sendOtp__2CeE6"};